let appMode = process.env.REACT_APP_APP_MODE;
let cdnPath = "https://cdn.pixalab.ai/";
const APP_NAME = "PixaLab";
export default {
    appName     : APP_NAME,
    cdnPath     : cdnPath,
    appLogo     : `${cdnPath}assets/pixalab/logo.png`,
    miniAppLogo : `${cdnPath}assets/pixalab/mini_logo.png`,
    appFavicon  : `${cdnPath}assets/pixalab/favicon.png`,
    apiUrl      : appMode == 'live' ? 'https://api.pixalab.ai/'     : appMode == 'dev' ?  'https://pixalabapi.pixelnx.com/' : 'http://localhost:4658/',
    appUrl      : appMode == 'live' ? 'https://app.pixalab.ai/'     : appMode == 'dev' ?  'https://pixalab.pixelnx.com/' : 'http://localhost:4657/',
    builderUrl  : appMode == 'live' ? "https://builder.pixalab.ai/" : "http://devbuilder.pixalab.ai/",
    // Tab title format. Page-first so tab strips read "<Page> · PixaLab" —
    // the page name stays visible when many tabs are squeezed together.
    pageTitle   : (page) => page ? `${page} · ${APP_NAME}` : APP_NAME,
};
